
export default {
  props: {
    primary: { type: Object, default: () => {} },
  },
};
